import { Injectable } from '@angular/core';

@Injectable()
export class GeoService {
  //https://angularfirebase.com/lessons/geofire-location-queries-with-google-maps/
  constructor() { }

}
